














































export default

	props: featuredCards: Array

	data: -> categories: []

	# Get the full list of product filter options, which will be used both to
	# translate category slugs and to determine the refinement list options we
	# show in the left sidbear
	fetch: ->
		{ @categories } = await @$craft.execute query: '''
			query {
				categories(group: "productFilterCategories", level: 1) {
					id, title, slug
					children { id, title, slug }
				}
			}
		'''

	computed:

		# Form the Algolia index name
		indexName: ->
			"#{process.env.APP_ENV}_#{@$route.params.collection}_products"

		# Make the list of refinement lists
		refinementLists: -> @categories.map (category) ->
			title: category.title
			attribute: "refinements.#{category.slug}"

		# Get just the category 2nd level options
		categoryChildren: -> @categories.reduce (children, parent) ->
			[ ...children, ...parent.children ]
		, []

		# Translate refinement list options (which are 2nd level category slugs)
		# into their titles
		refinementItemTitles: ->
			Object.fromEntries @categoryChildren.map (category) ->
				[category.slug, category.title]

	methods:
		loadMoreClicked: (refineNext) ->
			cards = document.querySelectorAll '.ais-InfiniteHits-item'
			lastCard = cards[cards.length - 1]
			pollId = setInterval ->
				if lastCard.nextSibling
					clearInterval pollId
					lastCard.nextSibling.querySelector('a').focus()
			, 100
			refineNext()

